import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import {
  FormControlLabel, Checkbox, Divider, Grid, Typography, Paper, Button, Select, MenuItem, FormControl, InputLabel, Dialog, DialogContent, IconButton
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';

import { ConstantsContext } from "../index";
import DashboardTopMenu from './DashboardTopMenu';
import DartsDesign2 from './DartsDesign2';
import SharpRatioView from './SharpRatioView';
import { SENTIMENT_COLORS, SENTIMENT_LABELS } from '../constants';


const colorsArr = SENTIMENT_COLORS;
const colorsNameArr = SENTIMENT_LABELS;
export default function RouteAdminAIAgents(props) {
  const [aiAgents, setAiAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [analysisData, setAnalysisData] = useState([]);
  const [context, setContext] = useState([]);
  const [top3Coins, setTop3Coins] = useState([]);
  const [sharpRatioTable, setSharpRatioTable] = useState([]);
  
  const [staticText] = useContext(ConstantsContext);

  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  
  const [ai_task_analyze_to_do, setAi_task_analyze_to_do] = useState(0);
  const [ai_task_top_3_last_update, setAi_task_top_3_last_update] = useState('');
  const [ai_task_top_3_last_update_time_ago, setAi_task_top_3_last_update_time_ago] = useState('');
  


  const [visibility, setVisibility] = useState({
    promptContext: true,
    top3Coins: true,
    charts: {
      darts: true,
      trend: true,
      price_levels: true,
      comment: true,
      'trading_view_1h': true,
      'trading_view_4h': true,
      'trading_view_1d': true,
      actionable_trading_strategy: true,
      oco_order_plan: true,
      '1H': true,
      '4H': true,
      '1D': true,
      '1M': true,
    },
  });

  const [csvReady, setCsvReady] = useState(false);

  const handleImageClick = (src) => {
    setSelectedImage(src);
    setOpenModal(true);
  };

  const history = useHistory();

  const changeHistory = (_from, _to) => {
    history.push(_to, { from: _from })
  };

  useEffect(() => {
    const data = [
      { key: 'action', value: 'get_ai_agents' },
      { key: 'loggined_token', value: props.userDetails.loggined_token }
    ];

    props._apiConnect(staticText.path_user, data, (res) => {
      if (res.status_code === 2) {
        setAiAgents(res.data);
        setSelectedAgent(res.data[0]);
        _api_get_analyse_for_coin_ids(res.data[0].id);
      }
    });
  }, [props._apiConnect, props.userDetails.loggined_token, staticText.path_user]);

  const seeMore = (agent) => {
    setSelectedAgent(agent);
    _api_get_analyse_for_coin_ids(agent.id);
  };

  function _api_get_analyse_for_coin_ids_callback(_data) {
    if (_data.status_code === 2) {
      setAnalysisData(_data.data || []);
      setContext(_data.promptContextJson || [])
      setTop3Coins(_data.ai_task_top_3_coinsRow[0].prompt_output ? JSON.parse(_data.ai_task_top_3_coinsRow[0].prompt_output) : [])
      setSharpRatioTable(_data.ai_task_top_3_coinsRow[0].prompt_output_sharp_ratio ? JSON.parse(_data.ai_task_top_3_coinsRow[0].prompt_output_sharp_ratio) : [])
      console.log('sss = ', _data.ai_task_top_3_coinsRow[0].prompt_output_sharp_ratio ? JSON.parse(_data.ai_task_top_3_coinsRow[0].prompt_output_sharp_ratio) : [])

      setAi_task_analyze_to_do(_data.ai_task_analyze_to_do || 0)
      setAi_task_top_3_last_update(_data.ai_task_top_3_last_update || '')
      setAi_task_top_3_last_update_time_ago(_data.ai_task_top_3_last_update_time_ago || '')
    }
  }

  const _api_get_analyse_for_coin_ids = (ai_agent_id) => {
    const data = [
      {'key':'action', 'value': 'get_analyse_for_coin_ids_for_ai_agent_by_id'},
      {'key':'loggined_token', 'value': props.userDetails.loggined_token},
      {'key':'ai_agent_id', 'value': ai_agent_id}
    ];

    props._apiConnect(staticText.path_darts, data, _api_get_analyse_for_coin_ids_callback);
  };

  // --- Per-coin CSV (last 180 daily candles) button ---
  function Csv180Button({ coinBase, userDetails, _apiConnect }) {
    const [loading, setLoading] = React.useState(false);
    const [csvUrl, setCsvUrl]   = React.useState("");
    const [error, setError]     = React.useState("");

    const handleGenerate = () => {
      setLoading(true);
      setError("");
      setCsvUrl("");

      const data = [
        { key: "action",         value: "generate_candles_1d_csv_coin180" },
        { key: "loggined_token", value: userDetails?.loggined_token || "" },
        { key: "coin",           value: coinBase } // e.g. "BTC"
      ];

      _apiConnect("https://cryptomarketdarts.com/api/darts/", data, (res) => {
        setLoading(false);
        if (res?.status_code === 2 && res?.csv_file) {
          // API returns "../ai_agent/csv/candles_1d_BTC_last180.csv"
          const relative = String(res.csv_file).replace(/^\.\.\//, ""); // "ai_agent/csv/.."
          const fullUrl  = `https://cryptomarketdarts.com/api/${relative}`;
          setCsvUrl(fullUrl);
        } else {
          setError(res?.msg || "Failed to generate CSV");
        }
      });
    };

    return (
      <div style={{ marginTop: 12 }}>
        <Button
          variant="contained"
          size="small"
          onClick={handleGenerate}
          disabled={loading}
        >
          {loading ? "Generating…" : "Get 180 Daily Candles"}
        </Button>

        {csvUrl && (
          <Button
            variant="outlined"
            color="success"
            size="small"
            href={csvUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginLeft: 8 }}
          >
            Download
          </Button>
        )}

        {error && (
          <Typography
            variant="caption"
            color="error"
            style={{ marginLeft: 8 }}
          >
            {error}
          </Typography>
        )}
      </div>
    );
  }

  const getRelativeTime = (dateString) => {
    const now = new Date();
    const past = new Date(dateString);
    const diffMs = now - past;

    const minutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    if (hours > 0) {
        return `${hours} hour${hours > 1 ? 's' : ''} ${remainingMinutes} minute${remainingMinutes !== 1 ? 's' : ''} ago`;
    } else {
        return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
    }
  };

  return (
    <Grid container spacing={2} style={{ width: '100%', margin: 0 }}>
      <DashboardTopMenu _apiLogOff={props._apiLogOff} userDetails={props.userDetails} />

      <Grid item xs={12} style={{ padding: '16px 24px' }}>

        <Paper style={{ padding: 16, backgroundColor: '#F9F9F9', border: '1px solid #ccc', margin: '24px 0' }}>
          <Typography variant="subtitle1">Last Update: <strong>{ai_task_top_3_last_update} - {ai_task_top_3_last_update_time_ago}</strong></Typography>
          {ai_task_analyze_to_do > 0 ? <Typography variant="subtitle1">Approximate processing time: <strong>{ai_task_analyze_to_do} minutes</strong></Typography>
          : null}
        </Paper>
        <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
          <Grid item>
            <Typography variant="h5">Selected AI Agent</Typography>
          </Grid>
          <Grid item>
            <FormControl size="small" style={{ minWidth: 200, backgroundColor: '#FFFFFF' }}>
              <InputLabel style={{ backgroundColor: '#FFFFFF' }}>AI Agent</InputLabel>
              <Select
                value={selectedAgent?.id || ''}
                label="AI Agent"
                onChange={(e) => {
                  const agent = aiAgents.find(a => a.id === e.target.value);
                  if (agent) seeMore(agent);
                }}
              >
                {aiAgents.map(agent => (
                  <MenuItem key={agent.id} value={agent.id}>{agent.username}</MenuItem>
                ))}
              </Select>
            </FormControl>

          </Grid>

          <Grid item>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  const data = [
                    { key: 'action', value: 'generate_candles_1d_csv' },
                    { key: 'loggined_token', value: props.userDetails.loggined_token }
                  ];
                  props._apiConnect(staticText.path_darts, data, (res) => {
                    if (res.status_code === 2) {
                      console.log('CSV Generation Success:', res);
                      setCsvReady(true);
                    } else {
                      console.error('CSV Generation Failed:', res);
                      setCsvReady(false);
                    }
                  });
                }}
              >
                Generate 1d Interval CSV
              </Button>

              {csvReady && (
                <Button
                  variant="contained"
                  color="success"
                  href="http://cryptomarketdarts.com/api/ai_agent/csv/candles_1d_merged.csv"
                  target="_blank"
                >
                  Download CSV File
                </Button>
              )}
            </div>
          </Grid>

        </Grid>

        {selectedAgent && (
          <Paper style={{ padding: 16, backgroundColor: '#F9F9F9', border: '1px solid #ccc', margin: '24px 0' }}>
            <Typography variant="subtitle1"><strong>{selectedAgent.username}</strong></Typography>
            <Typography variant="body2">Email: {selectedAgent.email}</Typography>
            <Typography variant="body2">Created: {selectedAgent.creation_date}</Typography>
            <Typography variant="body2">Paid: {selectedAgent.paid === "1" ? "Yes" : "No"}</Typography>
          </Paper>
        )}

        {/* Filters Section */}
        <Paper style={{ padding: 16, marginBottom: 24, backgroundColor: '#FFFDE7' }}>
          <Typography variant="h6">🔧 Filters</Typography>
          <FormControlLabel
            control={<Checkbox checked={visibility.promptContext} onChange={() => setVisibility(prev => ({ ...prev, promptContext: !prev.promptContext }))} />}
            label="Show Prompt Context"
          />
          <FormControlLabel
            control={<Checkbox checked={visibility.top3Coins} onChange={() => setVisibility(prev => ({ ...prev, top3Coins: !prev.top3Coins }))} />}
            label="Show Top 3 Coins"
          />
          <div style={{ marginTop: 8 }}>
            {['darts', 'trend', 'price_levels', 'comment', 'trading_view_1h', 'trading_view_4h', 'trading_view_1d', 'actionable_trading_strategy', 'oco_order_plan', '1M', '1H', '4H', '1D'].map(key => (
              <FormControlLabel
                key={key}
                control={<Checkbox checked={visibility.charts[key]} onChange={() =>
                  setVisibility(prev => ({
                    ...prev,
                    charts: { ...prev.charts, [key]: !prev.charts[key] }
                  }))
                } />}
                label={`Show : ${key}`}
              />
            ))}
          </div>
        </Paper>
        {visibility.promptContext && context && (
          <>
            <Typography variant="h6" gutterBottom>🧠 Prompt Context</Typography>
            
            {context.cash_summary && (
              <Paper style={{ padding: 16, marginBottom: 12 }}>
                <Typography variant="subtitle1">✅ Cash Summary</Typography>
                <Typography variant="body2">Available cash now: {context.cash_summary.available_cash_now}</Typography>
                <Typography variant="body2">Total cash after canceling all open orders: {context.cash_summary.total_cash_after_canceling_all_open_orders}</Typography>
                <Typography variant="body2">Cancelable cash balance: {context.cash_summary.cancelable_cash_balance}</Typography>
                <Typography variant="body2">P&L in cash: {context.cash_summary.p_and_l_in_cash}</Typography>
              </Paper>
            )}
            

            {/*Array.isArray(context.cash_movements) && context.cash_movements.length > 0 && (
              <Paper style={{ padding: 16, marginBottom: 12 }}>
                <Typography variant="subtitle1">🧾 Txn History</Typography>
                {context.cash_movements.map((item, i) => (
                  <Typography variant="body2" key={i}>
                    {item.date} | Action: {item.action} | Quantity: {item.quantity} | Coin: {item.coin}
                  </Typography>
                ))}
              </Paper>
            )*/}

            {Array.isArray(context.coin_holdings) && context.coin_holdings.length > 0 && (
              <Paper style={{ padding: 16, marginBottom: 12 }}>
                <Typography variant="subtitle1">💰 Current Portfolio Positions</Typography>
                {context.coin_holdings.map((item, i) => (
                  <Typography variant="body2" key={i}>
                    {item.symbol} {item.total_balance} (units) avg cost @ ${item.price}
                  </Typography>
                ))}
              </Paper>
            )}

            {/*Array.isArray(context.user_orders) && context.user_orders.length > 0 && (
              <Paper style={{ padding: 16, marginBottom: 12 }}>
                <Typography variant="subtitle1">🧠 [All] Order History</Typography>
                {context.user_orders.map((order, i) => (
                  <Typography variant="body2" key={i}>
                    date: {order.date} | order key: {order.order_key} | {order.action} {order.quantity} {order.symbol} @ {order.price} → Status: {order.status}
                  </Typography>
                ))}
              </Paper>
            )*/}
          </>
        )}
        <SharpRatioView sharpRatioTable={sharpRatioTable} visibility={visibility} />
        
        <Divider style={{ margin: '50px 0' }} />
        <Typography variant="h6" gutterBottom>📈 All Coins - Chart & Momentum View</Typography>
        
        <Grid container spacing={2}>
          {analysisData.map((coin) => {

            const baseCoin = (coin?.coin_pair_name || "").split("-")[0]; // e.g. "BTC"
            return (<Grid item xs={12} sm={6} md={4} key={coin.id}>
              <Paper style={{ padding: 16, marginBottom: 16, backgroundColor: '#F0F8FF', border: '1px solid #ccc' }}>
                <Typography variant="h6">
                  {coin.coin_pair_name} <small style={{ fontWeight: 'normal' }}>
                    (last update: {coin.date} — {coin.date_ago})
                  </small>
                </Typography>
                {/* CSV 180 Daily Candles (per coin) */}
                <Csv180Button
                  coinBase={baseCoin}
                  userDetails={props.userDetails}
                  _apiConnect={props._apiConnect}
                />
                {visibility.charts.darts && (
                  <DartsDesign2
                    key={coin["coin_pair_id"] + '_' + Math.random()} 
                    coinPairId={coin["coin_pair_id"]} 
                    name={(coin["coin_pair_name"])} 
                    userDetails={props.userDetails}
                    _values={coin}
                  />
                )}

                {visibility.charts.trend && (
                  <Typography variant="body2">
                    Trend:
                    {["_1h", "_4h", "_1d", "_1w", "_1m"].map(key => (
                      <span key={key} style={{
                        backgroundColor: colorsArr[coin[key]],
                        padding: '2px 6px',
                        margin: '0 4px',
                        color: 'black',
                        borderRadius: 4,
                        display: 'inline-block'
                      }}>
                        {key.toUpperCase().replace('_', '')}: {colorsNameArr[coin[key]]}
                      </span>
                    ))}
                  </Typography>
                )}
                {visibility.charts.price_levels && (
                  <>
                    <Typography variant="body2" style={{ marginTop: 8 }}>Price Levels:</Typography>
                    <Typography variant="body2" style={{ color: '#000', marginTop: 8 }}>
                      1W High Est: <strong>${coin.high1W}</strong>; 1W Low Est: <strong>${coin.low1W}</strong>
                    </Typography>
                    <Typography variant="body2" style={{ color: '#000' }}>
                      1D High Est: <strong>${coin.high1D}</strong>; 1D Low Est: <strong>${coin.low1D}</strong>
                    </Typography>
                    <Typography variant="body2" style={{ color: '#000' }}>
                      1H/4H High Est: <strong>${coin.high}</strong>; 1H/4H Low Est: <strong>${coin.low}</strong>
                    </Typography>
                  </>
                )}
                {visibility.charts.comment && (
                <Typography variant="body2" style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', marginTop: 10 }}>{coin.comment}</Typography>
                )}
                <Paper
                  key="chart_link_1h_4h_1d"
                  style={{
                    backgroundColor: '#fff',
                    padding: 16,
                    marginTop: 16,
                    boxSizing: 'border-box',
                  }}
                >
                  {visibility.charts.trading_view_1h && coin.chart_link_1h && (
                    <>
                      <h2 style={{ marginBottom: 8 }}>{coin.coin_pair_name} 1 Hour Chart</h2>
                      <img
                        src={coin.chart_link_1h}
                        alt="1H Chart"
                        onClick={() => handleImageClick(coin.chart_link_1h)}
                        style={{ width: '100%', cursor: 'pointer', display: 'block' }}
                      />
                    </>
                  )}

                  {visibility.charts.trading_view_4h && coin.chart_link && (
                    <>
                      <h2 style={{ marginTop: 24, marginBottom: 8 }}>{coin.coin_pair_name} 4 Hour Chart</h2>
                      <img
                        src={coin.chart_link}
                        alt="4H Chart"
                        onClick={() => handleImageClick(coin.chart_link)}
                        style={{ width: '100%', cursor: 'pointer', display: 'block' }}
                      />
                    </>
                  )}

                  {visibility.charts.trading_view_1d && coin.chart_link_1d && (
                    <>
                      <h2 style={{ marginTop: 24, marginBottom: 8 }}>{coin.coin_pair_name} 1 Day Chart</h2>
                      <img
                        src={coin.chart_link_1d}
                        alt="1D Chart"
                        onClick={() => handleImageClick(coin.chart_link_1d)}
                        style={{ width: '100%', cursor: 'pointer', display: 'block' }}
                      />
                    </>
                  )}
                </Paper>
                {/* Actionable Trading Strategy */}
                {
                  1== 2 && visibility.charts.actionable_trading_strategy && coin.actionable_trading_strategy ? (() => {
                    let strategy = null;
                    try {
                      strategy = typeof coin.actionable_trading_strategy === 'string'
                        ? JSON.parse(coin.actionable_trading_strategy)
                        : coin.actionable_trading_strategy;
                    } catch (e) {
                      console.error("Invalid actionableTradingStrategy JSON", e);
                    }
    
                    return strategy ? (
                      <Grid item xs={12}>
                        <Typography variant="h6">📊 Actionable Trading Strategy</Typography>
                        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {`- Entry Zone: ${strategy.entry_zone}
    - Stop-Loss: ${strategy.stop_loss}
    - Take Profit Targets: ${strategy.take_profit_targets?.join(', ')}
    - Trade Execution Strategy: ${strategy.strategy}
    - Risk Considerations: ${strategy.risk}`}
                        </pre>
                      </Grid>
                    ) : null;
                  })() : null
                }
    
                {/* OCO Order Plan */}
                {1 == 2 && visibility.charts.oco_order_plan && coin.oco_order_plan ? (() => {
                  let ocoPlan = null;

                  try {
                    ocoPlan = typeof coin.oco_order_plan === 'string'
                      ? JSON.parse(coin.oco_order_plan)
                      : coin.oco_order_plan;
                  } catch (e) {
                    console.error("Invalid OCO Order Plan JSON", e);
                  }

                  return Array.isArray(ocoPlan) && ocoPlan.length > 0 ? (
                    <Grid item xs={12}>
                      <Typography variant="h6">📑 OCO Order Plan</Typography>
                      <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                        {
                          ocoPlan.map(order =>
                            `${order.order_type} | Price: ${order.price} | Action: ${order.description} | ${order.position_percent}% (${order.units} units) | When: ${order.execution_condition}`
                          ).join('\n')
                        }
                      </pre>
                    </Grid>
                  ) : null;
                })() : null}

                {/* Coin Blog & Coin Article (JSON-aware) */}
{(() => {
  // Parse incoming value (object or JSON string or plain string)
  const parseEntry = (val) => {
    if (!val) return null;

    // If it's already an object, use it directly
    if (typeof val === 'object') return val;

    // If it's a JSON string, try to parse
    if (typeof val === 'string') {
      const s = val.trim();
      // try JSON first
      try {
        const obj = JSON.parse(s);
        if (obj && typeof obj === 'object') return obj;
      } catch (_) {}
      // otherwise treat it as plain text content
      return { title: '', content: s };
    }

    return null;
  };

  // Insert commas into 4+ digit numbers (keeps decimals, leaves already-comma'd values)
  const formatNumbersInText = (str) => {
    if (!str) return str;
    let out = String(str);

    // 1) Percentages: "12.345 %" or "12.345%"
    out = out.replace(/(-?\d+(?:\.\d+)?)(\s*%)/g, (_, num) => `${formatPercent(num)}%`);

    // 2) Dollar-prefixed prices/levels: "$1234.56789"
    out = out.replace(/\$(-?\d+(?:\.\d+)?)/g, (_, num) => `$${formatPriceLevel(num)}`);

    // 3) Bare numbers that look like prices/levels.
    //    Heuristics: either 4+ digits (likely level) OR any decimal number.
    //    Avoid touching parts of words/ids (skip if directly adjacent to word char, #, or hyphen).
    out = out.replace(/(^|[^A-Za-z0-9#-])(-?\d+(?:\.\d+)?)(?![A-Za-z0-9.%-])/g, (m, lead, num) => {
      // Skip if this number was already formatted as part of $… or …% (handled above)
      // Also skip weird decimals like "0.2,071"
      if (/,/.test(num.split('.')[1] || '')) return m;

      const abs = Math.abs(Number(num));
      const shouldFormat =
        !isNaN(abs) && (num.includes('.') || num.replace('-', '').length >= 4);

      return shouldFormat ? `${lead}${formatPriceLevel(num)}` : m;
    });

    return out;
  };

  function formatPriceLevel(value) {
    const n = Number(value);
    const abs = Math.abs(n);

    if (!isFinite(n)) return String(value);

    if (abs >= 1) {
      // Exactly 2 decimals
      return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } else if (abs >= 1e-4) {
      // Up to 4 decimals, trim trailing zeros
      return n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 4 });
    } else {
      // Up to 8 decimals, trim trailing zeros
      return n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 8 });
    }
  }

  // Percentages: TP1, TP2, TP3, RISK_CAP (number only; append % where you print it)
  function formatPercent(value) {
    const n = Number(value);
    if (!isFinite(n)) return String(value);
    return n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  const blog = parseEntry(coin.coin_blog_json ?? coin.coin_blog);
  const article = parseEntry(coin.coin_article_json ?? coin.coin_article);

  const hasBlog = !!blog && (blog.title || blog.content);
  const hasArticle = !!article && (article.title || article.content);

  if (!hasBlog && !hasArticle) return null;

  const Sentiment = ({ value }) => {
    if (!value) return null;
    const v = String(value).toLowerCase();
    const color =
      v === 'bullish' ? '#16a34a' :
      v === 'bearish' ? '#dc2626' :
      '#64748b'; // neutral/unknown
    return (
      <Typography
        variant="caption"
        sx={{
          ml: 1,
          px: 1,
          py: 0.25,
          borderRadius: 1,
          backgroundColor: `${color}1A`, // faint background
          color,
          fontWeight: 600,
        }}
      >
        {v}
      </Typography>
    );
  };



    const MetaLine = ({ entry }) => {
    const metaTitle = formatNumbersInText(entry?.meta_title || '');
    const metaDesc  = formatNumbersInText(entry?.meta_description || '');
    if (!metaTitle && !metaDesc) return null;

    return (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, whiteSpace: 'pre-wrap' }}>
        {metaTitle ? (<><strong>Meta Title:</strong> {metaTitle}<br/></>) : null}
        {metaDesc  ? (<><strong>Meta Description:</strong> {metaDesc}</>) : null}
      </Typography>
    );
  };

  const Section = ({ label, entry, icon }) => {
    if (!entry) return null;

    const title   = formatNumbersInText(entry?.title || '');
    const content = formatNumbersInText(entry?.content || '');

    return (
      <>
        <Typography variant="h6" gutterBottom>
          {icon} {label}
          <Sentiment value={entry.sentiment} />
        </Typography>

        {/* Title */}
        {title ? (
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5 }}>
            {title}
          </Typography>
        ) : null}

        {/* Meta: title/description if available */}
        <MetaLine entry={entry} />

        {/* Content (supports long text) */}
        {content ? (
          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', mt: 1 }}>
            {content}
          </Typography>
        ) : null}
      </>
    );
  };


  return (
    <Paper style={{ backgroundColor: '#fff', padding: 12, marginTop: 12 }}>
      {hasBlog && <Section label="CMD Blog" icon="📰" entry={blog} />}
      {hasBlog && hasArticle && <Divider sx={{ my: 1.5 }} />}
      {hasArticle && <Section label="CMD Article" icon="📄" entry={article} />}
    </Paper>
  );
})()}




                <Dialog open={openModal} onClose={() => setOpenModal(false)} maxWidth="lg">
                  <DialogContent style={{ position: 'relative', padding: 0 }}>
                    <IconButton
                      onClick={() => setOpenModal(false)}
                      style={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }}
                    >
                      <CloseIcon />
                    </IconButton>
                    <img
                      src={selectedImage}
                      alt="Full Chart"
                      style={{ width: '100%', height: 'auto', display: 'block' }}
                    />
                  </DialogContent>
                </Dialog>

                {coin.latest_charts && Object.entries(coin.latest_charts).map(([chartName, chartData]) => (
                  visibility.charts[chartName.replace('chart_', '').toUpperCase()] && (
                    <Paper key={chartName} style={{ backgroundColor: '#fff', padding: 12, marginTop: 12 }}>
                      <Typography variant="subtitle1" gutterBottom>
                        {chartName.toUpperCase().replace('_', ' ')}
                      </Typography>
                      <Grid container spacing={1}>
                        {Object.entries(chartData).map(([key, value]) => {
                          const formattedKey = key
                            .replace(/_/g, ' ')
                            .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize each word

                          return (
                            <Grid item xs={12} sm={6} key={key}>
                              <Typography variant="body2">
                                <strong>{formattedKey}:</strong> {value}
                              </Typography>
                            </Grid>
                          );
                        })}
                      </Grid>
                    </Paper>
                  )
                ))}
              </Paper>
            </Grid>
          )})}
        </Grid>
      </Grid>
    </Grid>
  );
}

const thStyle = {
  border: '1px solid #ccc',
  padding: '8px',
  backgroundColor: '#F5F5F5',
  color: 'black',
  textAlign: 'left'
};

const tdStyle = {
  border: '1px solid #ccc',
  padding: '8px',
  backgroundColor: '#F9F9F9',
  color: 'black'
};
